import { useSelector } from 'react-redux'

import projectSelectors from '../../store/selectors/project'
import authSelectors from '../../store/selectors/auth'

import {
  ILayout_Render_Context,
} from '@kaidam/fc-shared/src/types/layout'

const useLayoutRenderContext = (disableLinks = true): ILayout_Render_Context => {
  const info = useSelector(projectSelectors.projectInfo)
  const token = useSelector(authSelectors.token)

  let project = ''

  if(info && info.project) project = info.project

  return {
    project,
    token,
    disableLinks,
  }
}

export default useLayoutRenderContext